import { Console } from './platform-api';
var env = window.location.host;

if (env.includes('localhost') || env.includes('dev')) {
  Console('AWS Dev: ', '', 'log');
  (function (n, i, v, r, s, c, x, z) {
    x = window.AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
    window[n] = function (c, p) {
      x.q.push({ c: c, p: p });
    };
    z = document.createElement('script');
    z.async = true;
    z.src = s;
    document.head.insertBefore(z, document.getElementsByTagName('script')[0]);
  })(
    'cwr',
    'b156dc79-b317-4921-abbb-d9dffeeae482',
    '1.0.0',
    'ap-southeast-2',
    'https://client.rum.us-east-1.amazonaws.com/1.0.2/cwr.js',
    {
      sessionSampleRate: 1,
      guestRoleArn: 'arn:aws:iam::458119850496:role/accelerate_rum_unauthed_role',
      identityPoolId: 'ap-southeast-2:ac4567e5-6b61-4f89-8ba2-2d69be0972a7',
      endpoint: 'https://dataplane.rum.ap-southeast-2.amazonaws.com',
      telemetries: ['errors', 'performance', 'http'],
      allowCookies: true,
      enableXRay: true,
    },
  );
} else if (env.includes('staging')) {
  console.log('AWS Staging');
  (function (n, i, v, r, s, c, x, z) {
    x = window.AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
    window[n] = function (c, p) {
      x.q.push({ c: c, p: p });
    };
    z = document.createElement('script');
    z.async = true;
    z.src = s;
    document.head.insertBefore(z, document.getElementsByTagName('script')[0]);
  })(
    'cwr',
    '44baafbb-1915-4c35-9439-2664629d04b7',
    '1.0.0',
    'ap-southeast-2',
    'https://client.rum.us-east-1.amazonaws.com/1.0.2/cwr.js',
    {
      sessionSampleRate: 1,
      guestRoleArn: 'arn:aws:iam::978450690680:role/accelerate_rum_unauthed_role',
      identityPoolId: 'ap-southeast-2:4204fcab-4041-4b4a-a2f1-7aff6acae7c6',
      endpoint: 'https://dataplane.rum.ap-southeast-2.amazonaws.com',
      telemetries: ['errors', 'performance', 'http'],
      allowCookies: true,
      enableXRay: true,
    },
  );
} else {
  console.log('AWS Prod');
  (function (n, i, v, r, s, c, x, z) {
    x = window.AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
    window[n] = function (c, p) {
      x.q.push({ c: c, p: p });
    };
    z = document.createElement('script');
    z.async = true;
    z.src = s;
    document.head.insertBefore(z, document.getElementsByTagName('script')[0]);
  })(
    'cwr',
    'da808bff-0629-4e54-b888-aa67023c62c8',
    '1.0.0',
    'ap-southeast-2',
    'https://client.rum.us-east-1.amazonaws.com/1.0.2/cwr.js',
    {
      sessionSampleRate: 1,
      guestRoleArn: 'arn:aws:iam::262893720581:role/accelerate_rum_unauthed_role',
      identityPoolId: 'ap-southeast-2:70f7d9f4-6ff0-40a9-a9c2-c9414c50cfeb',
      endpoint: 'https://dataplane.rum.ap-southeast-2.amazonaws.com',
      telemetries: ['errors', 'performance', 'http'],
      allowCookies: true,
      enableXRay: true,
    },
  );
}
